import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import Body from './BlueBoxBody';
import Header from './BlueBoxHeader';

import './BlueBox.scss';

const BlueBox = ({ children, className }) => {
    const classes = classnames(className, 'blue-box');

    return (
        <div className={classes}>
            { children }
        </div>
    );
};

BlueBox.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

BlueBox.Body = Body;
BlueBox.Header = Header;

export default BlueBox;
